// @flow

// Fetch Saga Composer
import composeFetchSaga from 'fc-fetch-worker/src/sagas/composeFetchSaga'

// WebWorker
import worker from 'hfty-wrkr-soil-jobs'

export default function initialize (): Promise {
  const terminate = function terminate () {
    if (worker) {
      worker.terminate()
    }
  }

  return new Promise((resolve: Object) => {
    terminate()

    resolve({
      terminate,
      handleFetch: composeFetchSaga({
        getWorker: function (): Worker {
          return worker.getWorker()
        },
      }),
    })
  })
}
